import React from 'react'
/*import Searchbar from './base/Searchbar'*/

import CardProduct from './base/CardProduct'

import data from '../data'

const Home = () => {

 
  return (
    <div className='bg-base-200  '>
       
       
     
       
      {
          data.map((element, index)=><CardProduct 
                                              id={index}
                                              title={element.title}
                                              videoAccueil={element.videoAccueilID}
                                              description={element.description}
                                              playlistLink={element.lienPlaylistYoutube}
                                              free={element.freeNumber} 
                                    />)
      }
     
     
    </div>
  )
}

export default Home
